// ============================================================
// Palette di partenza per Stile — i 4 colori che il titolare può ritoccare
// in Impostazioni → Brand. Default REALI dell'editor: senza, mostrava sempre i
// colori "classico" anche per uno Stile diverso.
//
// ⚠️ FONTE CANONICA: templates/restaurant/site/src/config/styles.ts (il "ground"
// + primary/accent di ciascuno Stile). Il controllo scripts/check-style-palettes.ts
// FALLISCE in CI se questi valori driftano da styles.ts, così non possono
// scollarsi in silenzio. Vedi anche STYLE_BRAND lato API.
// ============================================================
export type BrandColors = { primary: string; background: string; text: string; accent: string };

export const STYLE_DEFAULTS: Record<string, BrandColors> = {
  classico: { primary: '#2F3D2E', background: '#FBF7EF', text: '#26241D', accent: '#B0833C' },
  editoriale: { primary: '#262320', background: '#FBFAF4', text: '#232019', accent: '#8C2F39' },
  contemporaneo: { primary: '#1E1E1B', background: '#FAFAF8', text: '#201F1C', accent: '#D23B2E' },
  artigianale: { primary: '#3A3026', background: '#FBF7EF', text: '#26241D', accent: '#C0613A' },
  minimal: { primary: '#232320', background: '#FAFAF8', text: '#201F1C', accent: '#7E8B6B' },
  mediterraneo: { primary: '#234E58', background: '#FBFAF4', text: '#232019', accent: '#2E8090' },
  artdeco: { primary: '#16140F', background: '#F6F3EC', text: '#1E1C16', accent: '#C9A24B' },
  robusto: { primary: '#2A211B', background: '#FBF7EF', text: '#26241D', accent: '#9C5B3B' },
  giocoso: { primary: '#2B2622', background: '#FFFDF8', text: '#2B2622', accent: '#E06A9C' },
};
